import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";
import cn from "classnames";
import { Header, Sidebar } from "@/shared/components";
import { BreadcrumbProvider, useAppSelector } from "@/shared/hooks";
import { clearMemoryDrafts } from "@/shared/utils";
import { selectSidebarCollapsed } from "@/features/settings";

export default function PrivateLayout() {
  const isCollapsed = useAppSelector(selectSidebarCollapsed);
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(function clearMemoryDraftsOnRouteChange() {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname;
      clearMemoryDrafts();
    }
  }, [pathname]);

  return (
    <BreadcrumbProvider>
      <div className="surface-secondary-fill min-h-screen">
        <Sidebar />
        <main
          className={cn(
            "flex flex-col min-h-screen transition-[padding-left] duration-300 ease-in-out",
            isCollapsed ? "pl-[88px]" : "pl-[280px]",
          )}>
          <Header />
          <div className="flex-1 flex flex-col pb-5 pr-5">
            <Outlet />
          </div>
        </main>
      </div>
    </BreadcrumbProvider>
  );
}

